export default "__VITE_ASSET__CPAvJjIY__"